import Vue from "vue";
//import dayjs from "dayjs";

const filters = {
  addEllipsesToLongTextFilter: Vue.filter("addEllipsesToLongText", (inputText, maxLength) => {
    let returnVal = inputText;
    if (inputText.length > maxLength) {
      returnVal = inputText.substring(0, maxLength) + "...";
    }
    return returnVal;
  })

  /*formateDate: Vue.filter("formateDate", date => {
    return dayjs(date).format("DD MMM YYYY");
  }),

  formateDateTime: Vue.filter("formateDateTime", date => {
    return dayjs(date).format("DD MMM YYYY HH:mm");
  })*/
};

export default filters;
